import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, ListItemText, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { AuthStore } from '../store/UserStore'
import { base_url } from '../utils/GlobalVariables'

const MyDialog = ({ dialogData = null, openDialog, handleCloseDialog, decryptedUser }) => {
    const logOut = AuthStore((state) => state.logOut)
    const [kontrak, setKontrak] = useState({})

    useEffect(() => {
        if (openDialog) {
            if (dialogData.kontrak !== "") {
                console.log('req kontrak');
                axios.get(
                    base_url + '/verif/kontrak/' + dialogData.kontrak,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`
                        }
                    })
                    .then((response) => {
                        console.log(response);
                        const data = response.data;
                        console.log(data);
                        setKontrak(data)
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                    })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openDialog])

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth="md"
            open={openDialog}
            onClose={handleCloseDialog}
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogTitle id="scroll-dialog-title">Detail Data</DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={2} sx={{ py: 4 }}>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <ListItemText primary="No. SPM" secondary={dialogData.no_spm} />
                                </TableCell>
                                <TableCell>
                                    <ListItemText primary="No. SPP" secondary={dialogData.no_spp} />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <ListItemText primary="Tanggal SPM" secondary={dialogData.tgl_spm} />
                                </TableCell>
                                <TableCell>
                                    <ListItemText primary="Jenis Pencairan" secondary={dialogData.jenis + " " + dialogData.jenis_ls} />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <ListItemText primary="Keperluan" secondary={dialogData.keperluan} />
                                </TableCell>
                                <TableCell>
                                    <ListItemText primary="Anggaran" secondary={"Rp " + rP(dialogData.anggaran)} />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Grid>
                <Grid container spacing={2} py={2} justifyContent="center">
                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Dokumen SPM dll</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + dialogData.id_opd + '/' + dialogData.jenis + '/spm/' + dialogData.file} />
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
                {
                    dialogData.progres > 2 &&
                    <Grid container spacing={2} py={2} justifyContent="center">
                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography>Surat Pengantar</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + dialogData.id_opd + '/pengantar_sp2d/' + dialogData.file} />
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                }
                {
                    dialogData.progres > 3 &&
                    <Grid container spacing={2} py={2} justifyContent="center">
                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                            <Accordion>
                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                    <Typography>Surat Perjanjian</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + dialogData.id_opd + '/' + dialogData.jenis + '/surat_perjanjian/' + dialogData.file} />
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                }
                {
                    dialogData.jenis === "LS" && dialogData.jenis_ls === "Modal" ?
                        <>
                            <Grid container spacing={2} py={2} justifyContent="center">
                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMore />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography>Dokumentasi</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + dialogData.id_opd + '/' + dialogData.jenis + '/dokumentasi/' + dialogData.file} />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} py={2} justifyContent="center">
                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMore />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography>Berita Acara</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + dialogData.id_opd + '/' + dialogData.jenis + '/berita_acara/' + dialogData.file} />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} py={2} justifyContent="center">
                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMore />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography>Progres</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + dialogData.id_opd + '/' + dialogData.jenis + '/progres/' + dialogData.file} />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </Grid>
                        </>
                        : ""
                }
                {
                    dialogData.jenis === "LS" && dialogData.jenis_ls === "Gaji" ?
                        <Grid container spacing={2} py={2} justifyContent="center">
                            <Grid item xs={12} sx={{ textAlign: "center" }}>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography>Daftar Gaji</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + dialogData.id_opd + '/' + dialogData.jenis + '/daftar_gaji/' + dialogData.file} />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>
                        : ""
                }
                {
                    dialogData.kontrak === "" ?
                        "" :
                        (
                            <Grid container spacing={2} py={2} justifyContent="center">
                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMore />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography>Kontrak</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + dialogData.id_opd + '/kontrak/' + kontrak.file} />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </Grid>
                        )
                }
                {
                    dialogData.jenis === "GU" ?
                        (
                            <Grid container spacing={2} py={2} justifyContent="center">
                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMore />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography>SPJ Fungsional</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + dialogData.id_opd + '/' + dialogData.jenis + '/spj_fungsional/' + dialogData.file} />
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </Grid>
                        )
                        : ""
                }
            </DialogContent>
            <DialogActions>
                <Button variant='contained' color='error' autoFocus onClick={handleCloseDialog}>
                    Tutup
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default MyDialog